<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    class="size-6"
    v-bind="$attrs"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M6 18 18 6M6 6l12 12"
    />
  </svg>
</template>

<script>
export default {
  name: "Bars3Icon",
  inheritAttrs: false,
};
</script>



// WEBPACK FOOTER //
// src/components/icons/XmarkIcon.vue